import { Space, Table, Tag, message } from "antd";
import { Dispatch, useEffect, useState } from "react";
import type { ColumnsType } from "antd/es/table/interface";
import { useTranslation } from "react-i18next";
import DeleteButton from "../../UI/DeleteButton/deletebutton";
import { deleteItemComponent } from "../../../api/itemComponent";
import { UseMutateAsyncFunction, useMutation } from "react-query";
import DeleteModal from "../../UI/ModalComponent/DeleteModal/deletemodal";
import { AxiosResponse } from "axios";

interface ItemComponentProps {
  paginatedItemComponent: any;
  ItemComponentMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      itemid: string | number | undefined;
      q: string;
      isActive?: boolean | undefined;
    },
    unknown
  >;
  filter: any;
  id: string | undefined;
  setPaginatedItemComponent: Dispatch<any>;
  search: any;
  isItemComponentLoading: boolean;
}
interface ItemComponentInterface {
  id: number;
  isActive: boolean;
  component: string;
}
const ComponentsList = ({
  ItemComponentMutation,
  filter,
  id,
  setPaginatedItemComponent,
  search,
  paginatedItemComponent,
  isItemComponentLoading,
}: ItemComponentProps) => {
  const [t] = useTranslation("common");

  useEffect(() => {
    ItemComponentMutation({
      itemid: id,
      q: search,
      isActive: filter,
    })
      .then((res) => {
        setPaginatedItemComponent(res.data);
      })
      .catch((error) => {
        // Handle error
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ItemComponentMutation, filter, id]);

  const deleteItemComponentMutation = useMutation(
    "deleteComponent",
    deleteItemComponent,
    {
      onSuccess: () => {
        ItemComponentMutation({
          itemid: id,
          q: search,
          isActive: filter,
        }).then((res) => {
          setPaginatedItemComponent(res.data);
          message.success("Complete successfully");
        });
      },
    }
  );
  const [open, setOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState<string | undefined>(undefined);
  const [, setNameToDelete] = useState<any>();

  const DeleteItemComponent = (
    id: string | undefined,
    component: string
  ): void => {
    setOpen(true);
    setIdToDelete(id);
    setNameToDelete(component);
  };

  const handleOk = () => {
    if (idToDelete) {
      deleteItemComponentMutation.mutate({ id: idToDelete });
    }
    setOpen(false);
  };

  const columns: ColumnsType<ItemComponentInterface> = [
    {
      title: `${t("id")}`,
      dataIndex: "id",
      key: "id",
      width: "4rem",
    },
    {
      title: `${t("component-name")}`,
      dataIndex: "component",
      key: "component",
      render: (record: any) => {
        return record ? record.name : null;
      },
    },
    {
      title: `${t("amount")}`,
      dataIndex: "quantity",
      key: "quantity",
      width: "9rem",
    },
    {
      title: `${t("status")}`,
      dataIndex: "isActive",
      key: "isActive",
      width: "5rem",
      align: "center",
      render: (record: any) =>
        record ? (
          <Tag className="active">{t("active")}</Tag>
        ) : (
          <Tag className="inactive">{t("inactive")}</Tag>
        ),
    },

    {
      title: `${t("action")}`,
      fixed: "right",
      width: "5rem",
      align: "center",
      render: (record: any) => (
        <Space size="middle">
          <DeleteButton
            onClick={() => DeleteItemComponent(record?.id, record?.component)}
          />
        </Space>
      ),
    },
  ];
  return (
    <>
      <DeleteModal open={open} setOpen={setOpen} name={""} onOk={handleOk} />
      <Table
        loading={isItemComponentLoading}
        scroll={{ x: 1000 }}
        columns={columns}
        pagination={{ pageSize: 8 }}
        dataSource={paginatedItemComponent}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        rowKey={(record) => record.id}
      />
    </>
  );
};

export default ComponentsList;
